// extracted by mini-css-extract-plugin
export default {"banner":"Banner_banner__HTrk+","info":"Banner_info__bCXhm","bannerImage":"Banner_bannerImage__H+xB9","startButton":"Banner_startButton__hznNI"};